import styled from "styled-components";

import { Modal } from "@similarweb/ui-components";

export const Container = styled(Modal.Content)`
    overflow-x: hidden;
    gap: 16px;
`;
